import { forwardRef, createElement } from 'react';

function IconHash(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M18.158 2.017a.75.75 0 01.59.79l-.015.102-1.047 4.841H20a.75.75 0 01.102 1.493L20 9.25h-2.638l-1.189 5.5H18.5a.75.75 0 01.102 1.493l-.102.007h-2.652l-1.115 5.159a.75.75 0 01-1.48-.216l.014-.101 1.046-4.842H7.848l-1.115 5.159a.75.75 0 01-1.48-.216l.014-.101 1.046-4.842H4a.75.75 0 01-.102-1.493L4 14.75h2.637l1.189-5.5H5.5a.75.75 0 01-.102-1.493L5.5 7.75h2.651l1.116-5.158a.75.75 0 011.48.216l-.014.1L9.686 7.75h6.465l1.116-5.158a.75.75 0 01.891-.575zM14.637 14.75l1.189-5.5H9.362l-1.189 5.5h6.464z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Hash = /*#__PURE__*/forwardRef(IconHash);

export default Hash;
//# sourceMappingURL=Hash.js.map
